import { Pipe, PipeTransform } from '@angular/core';
import {
  Permission,
  PermissionBtnType,
  PermissionTypes,
  Role,
} from '@data-access/roles';
import { WcgChipType } from '@wcg/frontend-framework';

@Pipe({
  name: 'hasPermission',
})
export class HasPermissionPipe implements PipeTransform {
  transform(
    role: Role,
    permission: Permission,
    permissionTypes: PermissionTypes[],
  ): PermissionBtnType | undefined {
    const rolePermissions = role.permissions.find(
      (p) => p.name.toLowerCase() === permission.name.toLowerCase(),
    ) as Permission;
    if (
      (rolePermissions && !Object.keys(rolePermissions).length) ||
      !permissionTypes.length
    ) {
      return undefined;
    }

    const result = permissionTypes.reduce(
      (acc, type) => {
        if (
          (type === 'canEdit' && rolePermissions?.canEdit) ||
          (type === 'canCreate' && rolePermissions?.canCreate)
        ) {
          acc = {
            chipType: WcgChipType.INFO,
            text: 'Write',
          };
        }
        if (type === 'canRemove' && rolePermissions?.canRemove) {
          acc = {
            chipType: WcgChipType.WARNING,
            text: 'Delete',
          };
        }
        if (type === 'canView' && rolePermissions?.canView) {
          acc = {
            chipType: WcgChipType.NEUTRAL,
            text: 'Read',
          };
        }
        return acc && Object.keys(acc as PermissionBtnType).length
          ? acc
          : undefined;
      },
      {} as PermissionBtnType | undefined,
    );

    return result;
  }
}
